<template>
    <div class="content">
        <div class="row animated fadeIn">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Sale Tasks</h4>
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active show" id="active-tab"
                                   data-toggle="tab" href="#activeTasks" role="tab" aria-controls="up" @click="changeTabs('active')">Active</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                                   href="#resolveTasks" role="tab" aria-controls="down" @click="changeTabs('resolved')">Resolved</a>
                            </li>
                          <li class="nav-item">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                                   href="#trafficTab" role="tab" aria-controls="down" @click="changeTabs('traffic')">Traffic</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body" style="padding-top: 0 !important;">
                        <div class="tab-content customer-table">
                            <div id="activeTasks" class="tab-pane active show" v-if="currentTab === 'active'">
                              <template v-if="!parentLoading">
                                <TaskList :tasks="activeSalesTasks" type="active" tableId="activeSalesTasksTable" />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                            <div id="resolveTasks" class="tab-pane fade" v-if="currentTab === 'resolved'">
                              <template v-if="!parentLoading">
                                <TaskList :tasks="resolvedSalesTasks" type="resolved" tableId="resolvedSalesTasksTable" />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                          <div id="trafficTab" class="tab-pane fade" v-if="currentTab === 'traffic'">
                            <template v-if="!parentLoading">
                                <Traffic type="traffic" tableId="traffic" />
                            </template>
                            <template v-else>
                              <div class="loader"></div>
                            </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <ManualTask task="Manual Tasks" type="sales"/>
    </div>
</template>

<script>
    import TempLinks from "@/components/Admin/Tools/tempLinks.vue";
    import ManualTask from "@/components/Admin/Sales/ManualTask.vue";
    import salesTaskMixin from "@/mixins/salesTaskMixin";

    export default {
        name: "TasksView",
        components: {
          ManualTask,
          TempLinks,
            TaskList: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/TaskList.vue"),
            Traffic: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/Traffic.vue"),
        },
       mixins: [salesTaskMixin],
        data () {
            return {
                initTables: false,
                currentTab: 'active',
                parentLoading: true,
            }
        },
        async mounted() {
          await this.fetchActiveSalesTasksSnapShot()
          setTimeout(()=>{
            this.parentLoading = false
          }, 500)
        },
        watch: {
            activeSalesTasks (value) {
              if(value){
                $(`#activeSalesTasksTable`).DataTable().destroy();
                setTimeout(()=>{
                  this.initSupportTasksTable('activeSalesTasksTable')
                }, 500)
              }
            },
        },
        methods: {
          async changeTabs(tabValue){
            if (tabValue === this.currentTab) {
              return false;
            }
            this.currentTab = tabValue;
            await this.setTabs()
            },
          async setTabs(){
              this.reInitDataTable()
              switch (this.currentTab) {
                case 'active': {
                  this.parentLoading = true
                  await this.fetchActiveSalesTasksSnapShot()
                  this.destroyPreviousSnapShots(this.currentTab)
                  setTimeout(()=>{
                    this.parentLoading = false
                  }, 500)
                  break;
                }
                case 'resolved': {
                  this.parentLoading = true
                  await this.fetchResolvedSalesTasks()
                  this.destroyPreviousSnapShots(this.currentTab)
                  setTimeout(()=>{
                    this.parentLoading = false
                  }, 500)
                  break;
                }
                case 'traffic' : {
                  this.parentLoading = true
                  setTimeout(()=>{
                    this.parentLoading = false
                  }, 500)
                  break;
                }
                default: {
                  console.log('Switched to another tab');
                  break;
                }
            }
          },
            reInitDataTable(){
                /* eslint-disable */
                $(`#activeSalesTasksTable`).DataTable().destroy();
                $(`#resolvedSalesTasksTable`).DataTable().destroy();
                /* eslint-enable */
                this.initTables = true;
            },
            initSupportTasksTable(el) {
                console.log('Loading datatable');
                /* eslint-disable */
                // if($.fn.DataTable.isDataTable( `#${el}` )){
                // 	$(`#${el}`).DataTable().destroy();
                // }
              $(`#${el}`).DataTable({
                pagingType: "full_numbers",
                lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
                destroy: true,
                retrieve: true,
                deferRender: true,
                "ordering": false,
                stateSave: true,
                language: {
                  search: "_INPUT_",
                  searchPlaceholder: "Search Task",
                  size: 50
                }
              });
                /* eslint-enable */
            },
            destroyPreviousSnapShots(ignoreSnapShot){
              const snapShots = {
                'active' : this.activeSalesTaskListener,
              };
              let snapShotKeys = Object.keys(snapShots);
              snapShotKeys = snapShotKeys.filter((value)=> value !== ignoreSnapShot);
              for (const snapShot of snapShotKeys){
                if(snapShots[snapShot]){
                  console.log('destroyed this one', snapShot)
                  snapShots[snapShot]()
                }
              }
            },
        },

        destroyed() {
            console.log('Detaching  sales tasks listeners on admin side...');
            this.destroyPreviousSnapShots('all')
            this.$store.dispatch('tasks/resetResolvedSalesListener');
        }
    }
</script>

<style scoped>
::v-deep .dataTables_wrapper .dataTables_filter input::-webkit-search-cancel-button {
  -webkit-appearance: button !important;
}
    .nav-tabs .nav-item .nav-link.active:before,
    .nav-tabs .nav-item .nav-link.active:hover:before,
    .nav-tabs .nav-item .nav-link.active:focus:before {
        border: 0;
    }

    .nav-tabs {
        border-bottom: 1px solid #dee2e6;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent !important;
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
    }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        color: #495057;
        background-color: #fff;
        border-color: #dee2e6 #dee2e6 #fff !important;
    }

    .nav-tabs .nav-item .nav-link.active {
        color: #5B7CFB;
    }
</style>
